import { UpsellNames } from '~/enums/Product'

import type { PromoKind, UpsellStatusNames } from '~/enums/Product'

type UpsellName = `${UpsellNames}`
type UpsellStatus = `${UpsellStatusNames}`

export type UpsellStatusDescriptor = {
  status: UpsellStatus
  upsell: Pick<Upsell, 'name' | 'price' | 'description'>
}

export type Product = {
  id: number
}

export const PRODUCT_KINDS = [
  'campaign',
  ...Object.values(UpsellNames),
] as const
export type ProductKind = (typeof PRODUCT_KINDS)[number]

export type Upsell = {
  description: string
  name: UpsellName
  price: number
} & Product

export type Promo = {
  code: string
  should_expire: boolean
  expiration_date: string
  date_created: string
  kind: PromoKind | string
  actions: {
    [K in ProductKind]: {
      value: number
      is_percentage: boolean
    }
  }
} & Product

export type ProgressivePromo = Pick<Promo, 'code' | 'actions'> & {
  kind: PromoKind.PROGRESSIVE
  progressive_parameters: {
    min_influencers: number
  }
} & Product

export type GrooverPlusPromo = Promo & {
  kind: PromoKind.GROOVER_PLUS
}
